import { Toaster } from '@/components/ui/toaster';
import { Toaster as Sonner } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from '@/routes';
import { useOfflineQueue } from '@/hooks/useOfflineQueue';

const App = () => {
  // Process offline queue when coming back online
  useOfflineQueue();

  return (
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </TooltipProvider>
  );
};

export default App;
